import { render } from "./SelectTenant.vue?vue&type=template&id=62659574&scoped=true"
import script from "./SelectTenant.vue?vue&type=script&lang=js"
export * from "./SelectTenant.vue?vue&type=script&lang=js"

import "./SelectTenant.vue?vue&type=style&index=0&id=62659574&scoped=true&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62659574"]])

export default __exports__